import { useState } from "react";
import "./FichaTecnica.css";
import PermissionGate from "../CadastroPerfilUsuario/PermissionGate";
import { Autocomplete, TextField, Select, MenuItem, FormControl, InputLabel, InputAdornment, IconButton } from "@mui/material";

function ItemsFichaTecnicaFormulario({ botao, eventoTeclado, cadastrarItemsFichaTecnica, alterarItemsFicha, materiaPrimas = [], objItemsFicha = {}, remover, onEncaixeManual }) {
    // ...existing code...

    const [selecionado, setSelecionado] = useState(null); // Armazena o material selecionado
    const [mostrarSugestoes, setMostrarSugestoes] = useState(false); // Controla a exibição da lista
    const [corSelecionada, setCorSelecionada] = useState("");// Estado para armazenar a cor da matéria-prima selecionada
    const [searchBy, setSearchBy] = useState('descricao'); // 'descricao' or 'codigoMateria'
    const [currentSearchInput, setCurrentSearchInput] = useState(''); // New state
    const [filteredMateriaPrimas, setFilteredMateriaPrimas] = useState([]); // New state
 
    // Função para selecionar um material
    const selecionarMateriaPrima = (materiaPrima) => {
        setSelecionado(materiaPrima); // Salva o item selecionado
        setMostrarSugestoes(false); // Esconde a lista de sugestões
        setCorSelecionada(materiaPrima ? materiaPrima.cor : "");
        handleMateriaPrimaChange({ target: { name: "idMateriaPrima", value: materiaPrima ? materiaPrima.id : "" } }); // Atualiza o estado no componente pai
    };

    const handleMateriaPrimaChange = (event) => {
        eventoTeclado(event);
    };


    return (
        <form >
            <select
                value={objItemsFicha?.estrutura || ''}
                onChange={eventoTeclado}
                name="estrutura"
                className="form-select"
            >
                <option value="">Selecione uma estrutura</option>
                <option value="ACABADO">ACABADO</option>
                <option value="SOLADO">SOLADO</option>
                <option value="CABEDAL">CABEDAL</option>
            </select>


            <input
                type="text"
                value={objItemsFicha?.componentes || ''}
                onChange={eventoTeclado}
                name="componentes"
                placeholder="Componentes"
                className="form-control"
                style={{ height: '28px', fontSize: '0.95rem', margin: '1px 0' }}
            />


            {/* ...campos de grade removidos para novo modal... */}

            {/* Campo antigo de consumo manual (opcional, pode remover depois) */}
            <input
                type="number"
                value={objItemsFicha.consumo || ''}
                onChange={eventoTeclado}
                name="consumo"
                placeholder="Consumo (manual - opcional)"
                className="form-control"
                style={{ height: '28px', fontSize: '0.95rem', margin: '1px 0' }}
                min="0"
                step="0.01"
            />

            

            {/* CÓDIGO COMENTADO - Upload de arquivo DXF e campos relacionados */}
            {/* Este código foi comentado pois agora utilizamos apenas o Encaixe Manual DXF */}
            {/* 
            <div>
                <label>Arquivo DXF</label>
                <input
                    type="file"
                    name="dxfFile"
                    onChange={eventoTeclado}
                    className="form-control"
                />
            </div>

                {objItemsFicha?.dxfFile && (
                    <>
                        <select
                            value={objItemsFicha?.tipoCalculo || 'metroLinear'}
                            onChange={eventoTeclado}
                            name="tipoCalculo"
                            className="form-select"
                        >
                            <option value="metroLinear">Metro Linear</option>
                            <option value="metroQuadrado">Metro Quadrado</option>
                        </select>

                        <input
                            type="number"
                            name="quantidadePares"
                            value={objItemsFicha.quantidadePares || ''}
                            onChange={eventoTeclado}
                            placeholder="Quantidade de Pares"
                            className="form-control"
                            style={{ height: '28px', fontSize: '0.95rem', margin: '1px 0' }}
                        />
                        <input
                            type="number"
                            name="quantidadePeca"
                            value={objItemsFicha.quantidadePeca || ''}
                            onChange={eventoTeclado}
                            placeholder="Quantidade de Peça Por (Pé)"
                            className="form-control"
                            style={{ height: '28px', fontSize: '0.95rem', margin: '1px 0' }}
                        />
                        <input
                            type="number"
                            name="espacamento"
                            value={objItemsFicha.espacamento || ''}
                            onChange={eventoTeclado}
                            placeholder="Espaçamento (mm)"
                            className="form-control"
                            style={{ height: '28px', fontSize: '0.95rem', margin: '1px 0' }}
                        />
                        {objItemsFicha?.tipoCalculo === 'metroLinear' && (
                            <>
                                <input
                                    type="number"
                                    name="larguraMaterial"
                                    value={objItemsFicha?.larguraMaterial || ''}
                                    onChange={eventoTeclado}
                                    placeholder="Largura do Material (mm)"
                                    className="form-control"
                                    style={{ height: '28px', fontSize: '0.95rem', margin: '1px 0' }}
                                />
                                <input
                                    type="number"
                                    name="alturaMaterial"
                                    value={objItemsFicha?.alturaMaterial || ''}
                                    onChange={eventoTeclado}
                                    placeholder="Altura do Material (mm)"
                                    className="form-control"
                                    style={{ height: '28px', fontSize: '0.95rem', margin: '1px 0' }}
                                />
                            </>
                        )}
                        <input
                            type="number"
                            name="percentualPerda"
                            value={objItemsFicha.percentualPerda || ''}
                            onChange={eventoTeclado}
                            placeholder="Percentual de Perda (%)"
                            className="form-control"
                            style={{ height: '28px', fontSize: '0.95rem', margin: '1px 0' }}
                            min="0"
                            step="0.01"
                        />
                    </>
                )}
            */}


            <select
                value={objItemsFicha?.tamanho || ''}
                onChange={eventoTeclado}
                name="tamanho"
                className="form-select"
            >
                <option value="">Selecione uma numeração (opcional)</option>
                <option value="30">28</option>
                <option value="36">36</option>
                <option value="39">39</option>
            </select>

            <FormControl fullWidth margin="normal">
                <InputLabel id="search-by-label">Pesquisar por</InputLabel>
                <Select
                    labelId="search-by-label"
                    value={searchBy}
                    label="Pesquisar por"
                    onChange={(event) => setSearchBy(event.target.value)}
                >
                    <MenuItem value="descricao">Descrição</MenuItem>
                    <MenuItem value="codigoMateria">Código da Matéria</MenuItem>
                </Select>
            </FormControl>

            <Autocomplete
                options={searchBy === 'codigoMateria' ? (filteredMateriaPrimas || []) : (materiaPrimas || [])}
                getOptionLabel={(option) => (option && option.descricao) ? option.descricao : ""}
                isOptionEqualToValue={(option, value) => (option && value) ? option.id === value.id : false}
                value={selecionado || null}
                onChange={(event, newValue) => {
                    selecionarMateriaPrima(newValue);
                }}
                onInputChange={(event, newInputValue) => {
                    setCurrentSearchInput(newInputValue); // Update current search input
                    setMostrarSugestoes(true); // Keep suggestions open while typing
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Buscar Matéria Prima"
                        variant="outlined"
                        fullWidth
                        sx={{
                            "& .MuiInputBase-input": {
                                backgroundColor: corSelecionada,
                            },
                        }}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {searchBy === 'codigoMateria' && (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => {
                                                    const trimmedInputValue = currentSearchInput.trim().toLowerCase();
                                                    const filtered = materiaPrimas.filter((option) => {
                                                        const codigoMateria = String(option.codigoMateria || '').toLowerCase();
                                                        return codigoMateria.includes(trimmedInputValue);
                                                    });
                                                    setFilteredMateriaPrimas(filtered);
                                                    setMostrarSugestoes(true); // Ensure suggestions are shown after search
                                                }}
                                                edge="end"
                                            >
                                                Pesquisar
                                            </IconButton>
                                        </InputAdornment>
                                    )}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}
                    />
                )}
                // Render options to show more details
                renderOption={(props, option, state) => (
                    <li {...props} key={`${(option && option.id) || 'opt'}-${state.index}`}>
                        {(option && option.descricao) || ''} {(option && option.codigoMateria) || ''} {(option && option.cor) || ''} R$ {(option && option.custo) || ''}
                    </li>
                )}
                // Filter options based on input value
                filterOptions={(options, { inputValue }) => {
                    if (searchBy === 'descricao') {
                        const trimmedInputValue = inputValue.toLowerCase();
                        return options.filter((option) => {
                            const descricao = String(option.descricao || '').toLowerCase();
                            return descricao.includes(trimmedInputValue);
                        });
                    } else if (searchBy === 'codigoMateria') {
                        // When searching by codigoMateria, return all options initially.
                        // Filtering will be triggered by the "Pesquisar" button.
                        return options;
                    }
                    return []; // Should not happen
                }}
                // Open suggestions when input is focused
                onOpen={() => setMostrarSugestoes(true)}
                onClose={() => setMostrarSugestoes(false)}
                // Control open state based on `mostrarSugestoes`
                open={mostrarSugestoes}
            />

            {/* Add the search button here, conditionally rendered */}
            {searchBy === 'codigoMateria' && (
                <button
                    type="button"
                    onClick={() => {
                        const trimmedInputValue = currentSearchInput.trim().toLowerCase();
                        const filtered = materiaPrimas.filter((option) => {
                            const codigoMateria = String(option.codigoMateria || '').toLowerCase();
                            return codigoMateria.includes(trimmedInputValue);
                        });
                        setFilteredMateriaPrimas(filtered);
                        setMostrarSugestoes(true); // Ensure suggestions are shown after search
                    }}
                    className="btn btn-primary" // You might need to define this class in your CSS
                >
                    Pesquisar
                </button>
            )}

            {/* Exibição da matéria-prima selecionada */}
            {selecionado && (
                <div className="selected-item">
                    <strong>Selecionado:</strong> {(selecionado && selecionado.descricao) || ''} - Cor: {(selecionado && selecionado.cor) || ''}
                </div>
            )}

            {/* <select
                value={objItemsFicha?.idProduto || produtoSelecionado || ""}
                onChange={eventoTeclado}
                name="idProduto"
                className="form-control"
            >
                <option value="">Selecione o Produto</option>
                {produtos.map((produto) => (
                    <option key={produto.idProduto} value={produto.idProduto}>
                        {produto.nomeModelo}
                    </option>
                ))}
            </select> */}

            <div className="modal-buttons">
                {botao ? (
                    <div className="modal-actions">
                        <PermissionGate permissions={["fichaTecnicaItensCadastrar"]}>
                            <button type="button" onClick={cadastrarItemsFichaTecnica} className='modal-button modal-button-primary'>
                                Cadastrar
                            </button>
                        </PermissionGate>
                    </div>
                ) : (
                    <div className="modal-actions">
                        <PermissionGate permissions={["fichaTecnicaItensAlterar"]}>
                            <button type="button" onClick={alterarItemsFicha} className='modal-button modal-button-warning'>
                                Alterar
                            </button>
                        </PermissionGate>

                        <PermissionGate permissions={["fichaTecnicaItensRemover"]}>
                            <button type="button" onClick={remover} className='modal-button modal-button-danger'>
                                Remover
                            </button>
                        </PermissionGate>
                    </div>
                )}
            </div>
        </form>
    );
}

export default ItemsFichaTecnicaFormulario;